import { ValidationRule } from './nodeTypes'

export type BasicAnswer = {
    name: string
    value: 'Yes' | 'No'
}

export type DateRangeType = {
    start: string
    end: string
}

export interface IAnswers {
    name: string
    value: string
}

export interface IsmokingTypeValue {
    type: 'Cigars' | 'RollUps' | 'Cigarettes' | 'Pipe'
    perDay: number
    years: number
}

export type SmokingTypeAnswer = {
    name: 'smokingType'
    value: Array<IsmokingTypeValue>
    type: 'smokingType'
}

export type DateRangeTypeAnswer = {
    name: 'UnavailableDatesPatient'
    value: DateRangeType
    type: 'DateRangeMatrix'
}

export interface FieldRules {
    stop?: boolean
    required?: { message: string }
    range?: { min: number; max: number; message: string }
    format?: { regex: RegExp; message: string }
}

export type FormValues = string | boolean | DateRangeType | undefined | number;
export interface FieldState {
    value?: FormValues
    rules?: ValidationRule
    state?: {
        error?: string
        approval: boolean
    }
}

export interface FormState {
    [key: string]: FieldState
}

export const initialState: FormState = {}

interface ILabel {
    display: boolean
}
interface ITitle {
    display: boolean
}

interface ISubTitle {
    display: boolean
}
export interface IComponentMetaData {
    label?: ILabel
    title?: ITitle
    subTitle?: ISubTitle
}
